export enum DIFY_TILE_TEST {
  Enabled1 = 'DifyTileTestEnabled1',
  Enabled2 = 'DifyTileTestEnabled2',
  Control = 'DifyTileTestControl',
}

export const DIFY_TILE_TEST_1 = {
  CTA_TEXT: 'Design from $10',
  CAPTION_TEXT: 'Work with a professional designer to craft a design that’s just right for you.',
}

export const DIFY_TILE_TEST_2 = {
  CTA_TEXT: 'Custom design from $10',
  CAPTION_TEXT: 'Get a professional design from scratch.',
  HEADING_TEXT: 'Work with a designer',
}

export const DIFY_TILE_EXPERIMENT_NAME = 'fy25_q4_difytiletest_round3'
